class TrackMyOrderProcessController {
    constructor(settings) {
        this.settings = settings;
    }

    get headingText() {
        if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.pickup) {
            return 'Pick Up';
        }
        if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.delivery) {
            return 'Delivery';
        }
        if (this.tmoInfo.DeliveryMethod === this.settings.trackMyOrderDeliveryMethod.express) {
            return 'Delivery Now';
        }
        return '';
    }
}

TrackMyOrderProcessController.$inject = ['Settings'];

const trackMyOrderProcessComponentDefinition = {
    controller: TrackMyOrderProcessController,
    template: require('./track-my-order-process.component.html').trim(),
    bindings: {
        tmoInfo: '<',
    },
};

module.exports = {
    TrackMyOrderProcessController,
    trackMyOrderProcessComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/track-my-order-process.component.js